module.exports = __webpack_public_path__ + "static/media/managementStore.d813f5b2.svg";